import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { IStoreValue } from "utils/types";
import { useNavigate } from "react-router-dom";

const RentalReviewConfirmationModal = ({ isOpen, onClose, RenterId, EquipId, orderId }) => {
  
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const AuthToken = useSelector(
    (state: IStoreValue) => state.equipmentReducer.accessToken
  );
  const AuthUserId = useSelector(
    (state: IStoreValue) => state.equipmentReducer.Authuser
  );
  const handleRedirection = () => {
    const redirectPath = `/rate-rental/${AuthUserId}/${RenterId}/${orderId}/${EquipId}/owner`;
    navigate(redirectPath);  
  }; 

  return (
    <Modal
      keepMounted
      open={isOpen}
      onClose={onClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "80%",
            sm: "400px",
            md: "500px",
            lg: "500px",
            xl: "500px",
          },
          bgcolor: "#2e2e2e",
          border: "5px solid #faa61a",
          borderRadius: "10px",
          outline: "none !important",
          p: 3,
        }}
      >
        <Box>
          <Box>
            <IconButton
              sx={{
                position: "absolute",
                top: "-20px",
                right: "-20px",
                bgcolor: "#faa61a",
                color: "#000",
                "&:hover": {
                  bgcolor: "#faa61a",
                },
              }}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
            
            <Typography
                  className="download-text"
                  id="keep-mounted-modal-title"
                  component="p"
                  sx={{
                    textAlign: "center",
                    color: "#fff !important",
                    fontSize: "20px !important",
                    fontFamily: "GothamBold !important",
                  }}
                >
                Success!, would you like to review this renter?
                </Typography>
                <Box className="chat-not-me">
                  <Box className="chat-btn-grp">
                    <Button
                      className="reject-btn"
                      type="button"
                      variant="contained"
                      sx={{
                        fontSize: "16px !important",
                        fontFamily: "GothamBold !important",
                      }}
                      onClick={onClose}
                    >
                      No
                    </Button>

                    <Button
                      className="accept-btn"
                      type="button"
                      variant="contained"
                      onClick={() => handleRedirection()}                    
                      sx={{
                        fontSize: "16px !important",
                        fontFamily: "GothamBold !important",
                      }}
                    >
                      YES
                    </Button>
                  </Box>
                </Box>
            
          </Box>
        </Box>

      </Box>
    </Modal>
  );
};

export default RentalReviewConfirmationModal;